<template>
  <div class="collapse__container" :class="{'remove-borders': !isOpen}">
    <div class="collapse__container__header" :class="{'remove-header-borders': isOpen}">
      <div class="d-flex cursor-pointer" @click="toggleCollapse">
        <div class="collapse__container__header__icon">
          <span class="dot text-center">
            <i v-if="isOpen" class="fas fa-minus-circle orange-icon" />
            <i v-else class="fas fa-plus-circle sucess-icon" />
          </span>
        </div>
        <div class="collapse__container__header__title">
          <span class="bold mr-2">{{value.behaviorType.text}}</span>
          <span class="text-muted">{{value.behaviorType.description}}</span>
        </div>
      </div>
      <div
        v-if="isEditable"
        class="cursor-pointer"
        @click="remove"
      >
        <i class="far fa-times-circle text-red"/>
      </div>
    </div>
    <div v-if="isOpen" class="collapse__container__body">
      <div v-if="!isEditable || showEditButton">
        <InappropriateBehaviorReadonly
          :value="value"
        />
        <div style="padding: 0 20px;">
          <div class="collapse__container__body__edit__actions">
            <ActionButton
              v-if="isEditable"
              type="button"
              text="Editar"
              i="fas fa-pencil-alt"
              variant="success"
              class="px-4"
              @click="setEdition"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <InappropriateBehaviorForm
          ref="updateInappropriateBehavior"
          v-model="editableModel"
          style="background-color: white"
          :behavior-type-options="behaviorTypeOptions"
          :behavioral-function-options="behavioralFunctionOptions"
          :behavioral-plan-options="behavioralPlanOptions"
        />
        <div style="padding: 0 20px;">
          <div class="collapse__container__body__edit__actions">
            <ActionButton
              type="button"
              text="Cancelar"
              i="fa fa-times-circle"
              variant="outline-danger"
              class="px-4 mr-3"
              @click="showEditButton = true"
            />

            <ActionButton
              type="button"
              text="Guardar"
              i="fas fa-save"
              variant="success"
              class="px-4"
              @click="update"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import InappropriateBehaviorForm from './Form.vue';
import { GetDefaultInappropriateBehavior } from './Form.vue';
import InappropriateBehaviorReadonly from "./Readonly.vue";

export default {
  name: 'InappropriateBehaviorCollapsable',
  components: {
    ActionButton,
    InappropriateBehaviorForm,
    InappropriateBehaviorReadonly
  },
  props: {
    isOpen: false,
    value: {
      type: Object,
      required: true,
      default: () => (GetDefaultInappropriateBehavior()),
    },
    isEditable: {
      type: Boolean,
      required: true,
      default: true,
    },
    behaviorTypeOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    behavioralFunctionOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    behavioralPlanOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      showEditButton: true,
      editableModel: {...this.value},
    };
  },
  computed: {
  },
  methods: {
    remove() {
      this.$emit('remove', this.value.id);
    },
    toggleCollapse() {
      if (this.isOpen) {
        this.$emit('close');
        return;
      }

      this.$emit('open');
    },
    setEdition() {
      this.showEditButton = false;
      this.editableModel = {...this.value};
    },
    async update() {
      const isValid = await this.$refs.updateInappropriateBehavior.validate();
      if (!isValid) return;

      this.$emit('update', this.editableModel);
    },
  },
  watch: {
    isOpen(newValue) {
      if(newValue) {
        this.showEditButton = true;
      }
    },
  },
  async mounted() {
  },
};
</script>

<style scoped>
.orange-icon {
  color: #FF7058;
}

.sucess-icon {
  color: #5bb486;
}

.remove-borders {
  border: 0 !important;
}

.remove-header-borders {
  border-left: 0 !important;
  border-right: 0 !important;
}

.collapse__container {
  margin: 10px 25px;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #c6cdcf;
  border-top: 0;
}

.collapse__container__header {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #c6cdcf;
}

.collapse__container__header__icon {
  margin-right: 10px;
}

.collapse__container__body {
}

.collapse__container__body__edit__actions {
  padding: 20px 0;
  display: flex;
  align-items: end;
  justify-content: end;
}
</style>
